const KEY_IS_COMPROMISED = 'KeyCompromise';
const SUBJECT_DATA_CHANGED = 'AffiliationChanged';
const REPLACED = 'Superseded';
const SERVICE_TERMINATED = 'CessationOfOperation';
export default [
  {
    label: 'Ключ скомпрометирован',
    value: KEY_IS_COMPROMISED,
  },
  {
    label: 'Изменены даные субъекта',
    value: SUBJECT_DATA_CHANGED,
  },
  {
    label: 'Заменен',
    value: REPLACED,
  },
  {
    label: 'Обслуживание прекращено',
    value: SERVICE_TERMINATED,
  },
];
